import React, { useState } from "react";
import { Phone, MessageCircle, X, HelpCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function FloatingHelp() {
  const { t, settings } = useApp();
  const [open, setOpen] = useState(false);
  const phone = settings?.helpline_phone || "9603333685";

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3" data-testid="floating-help">
      {open && (
        <div className="animate-fade-up flex flex-col gap-2 items-end">
          <a data-testid="help-call" href={`tel:${phone}`} className="flex items-center gap-2 bg-saffron text-white px-4 py-2.5 rounded-full temple-shadow font-telugu text-sm font-semibold">
            <Phone className="w-4 h-4" /> {t("call_now")}: {phone}
          </a>
          <a data-testid="help-whatsapp" href={`https://wa.me/91${phone}?text=${encodeURIComponent("దేవాలయ బంధం - సహాయం కావాలి")}`} target="_blank" rel="noreferrer"
            className="flex items-center gap-2 bg-[#25D366] text-white px-4 py-2.5 rounded-full temple-shadow font-telugu text-sm font-semibold">
            <MessageCircle className="w-4 h-4" /> {t("whatsapp")}
          </a>
        </div>
      )}
      <button data-testid="help-toggle" onClick={() => setOpen((o) => !o)}
        className="btn-sacred border-0 rounded-full px-5 py-3.5 flex items-center gap-2 font-telugu font-semibold text-sm animate-glow">
        {open ? <X className="w-5 h-5" /> : <HelpCircle className="w-5 h-5" />}
        <span className="hidden sm:inline">{open ? "" : t("help_contact")}</span>
      </button>
    </div>
  );
}
